var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"pt-4 mb-4"},[_c('h1',{staticClass:"h3 mb-4"},[_vm._v("\n    "+_vm._s(_vm.$t('mission-page'))+"\n  ")]),_c('my-mission-excerpt'),_c('div',{staticClass:"my-4"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }